// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const usePerspectiveNameStyles = makeThemedStyles(
  "PerspectiveName",
  (theme) => ({
    root: {
      color: "rgba(16, 41, 117, 1)",
      letterSpacing: "0.05625px",
      fontWeight: 600,
      margin: "0",
      marginTop: "0.687em",
      fontSize: "15px",
      lineHeight: "1.5em",
    },
  })
);

const PerspectiveName = (props: React.PropsWithChildren<{}>) => {
  const styles = usePerspectiveNameStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default PerspectiveName;
